import React, { useContext, useState } from "react";
import { CustomText } from "../../components";
import { fonts } from "../../config";

import { hooks, masks } from "../../utils";

import { CircularProgress } from "@mui/material";

import { errorModal } from "../../components/modals/utils";
import { api } from "../../services";
import { useLocation } from "react-router-dom";
import ReservationForm from "./components/ReservationForm";
import WebcamModal from "./components/WebcamModal";
import GuestForm from "./components/GuestForm";
import GuestConfirmStep from "./components/GuestConfirmStep";
import { StylesForm } from "./styles";
import { StorageContext } from "../../contexts/StorageContext";
import VisitantForm from "./components/VisitantForm";
import TenantForm from "./components/TenantForm";
import ServiceProviderForm from "./components/ServiceProviderForm";
import ReservationFormADMIN from "./components/ReservationFormAdmin";
import StepHeader from "./components/StepHeader";
import Styles from "./styles/StylesForm";
import { MenssageWhatsapp } from "../../services/helpers/menssageWhatsapp";

export function checkBirthday(birthday: string) {
  if (birthday != undefined && birthday.length > 9) {
    const now: Date = new Date();
    const birthdayDate: Date = new Date(birthday);
    const answer = birthdayDate > now;
    return answer;
  } else {
    return false;
  }
}

const STEPS_SP = [
  {
    title: "Cadastro do Prestador de serviço",
    description: "Validação dos dados básicos de acesso:",
  },
  {
    title: "Cadastro da Facial",
    description: "Posicione seu rosto no centro da câmera:",
  },
];

const STEPS_DEFAULT = [
  {
    title: "Cadastro do Hóspede",
    description: "Validação dos dados básicos de acesso:",
  },
  {
    title: "Cadastro da Facial",
    description: "Posicione seu rosto no centro da câmera:",
  },
];

const STEPS_TENANT = [
  {
    title: "Cadastro do Inquilino",
    description: "Validação dos dados básicos de acesso:",
  },
  {
    title: "Cadastro da Facial",
    description: "Posicione seu rosto no centro da câmera:",
  },
];

const STEPS_VISITANT = [
  {
    title: "Cadastro do Visitante",
    description: "Validação dos dados básicos de acesso:",
  },
  {
    title: "Cadastro da Facial",
    description: "Posicione seu rosto no centro da câmera:",
  },
];

const STEPS_GUEST = [
  {
    title: "Dados da Estadia",
    description: "Validação dos dados básicos do locatário primário e do imóvel:",
  },
  {
    title: "Complemento de Dados",
    description: " A seguir, preencha seus dados adicionais para confirmar seu acesso como hóspede acompanhante:",
  },
  {
    title: "Cadastro da Facial",
    description: "Posicione seu rosto no centro da câmera:",
  },
];

const WHATSAPP_SUPPORT_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";

function Home() {
  const location = useLocation();
  const { loading, call } = hooks.useRequest();
  const [isMounted, setMount] = React.useState<any>(false);
  const [data, setData] = React.useState<any>(null);
  const [success, setSuccess] = React.useState<any>(false);
  const { dataAp, setDataAp } = useContext<any>(StorageContext);
  const [role, setRole] = useState<any>(null);
  const [currentStep, setCurrentStep] = React.useState(0);
  const [stepData, setStepData] = React.useState<any>({});

  const queryParams = new URLSearchParams(location.search);
  const Mount = React.useCallback(() => {
    if (queryParams.get("id") && queryParams.get("renterId")) {
      call(
        "reservation",
        api.getReservation({
          reservationId: queryParams.get("id"),
          renterId: queryParams.get("renterId"),
        }),
        async (response) => {
          if (response.ok) {
            let imgPrimary: any = null;
            let secondaryGuests: any = [...response.data?.secondaryGuests];

            setRole(response.data.subType);
            if (response.data?.primaryGuest?.imageId) {
              await call(
                null,
                api.getImage(response.data?.primaryGuest?.imageId),
                async (rImage) => {
                  if (rImage.ok) {
                    imgPrimary = rImage.data;
                  }
                }
              );
            }

            if (
              response?.data?.primaryGuest?.id === queryParams.get("renterId")
            ) {
              for (const item of secondaryGuests) {
                if (item.imageId) {
                  await call(
                    null,
                    api.getImage(item.imageId),
                    async (rImage) => {
                      if (rImage.ok) {
                        item.image = rImage.data;
                      }
                    }
                  );
                }
              }
            } else {
              for (const item of secondaryGuests) {
                if (item.id === queryParams.get("renterId")) {
                  if (item.imageId) {
                    await call(
                      null,
                      api.getImage(item.imageId),
                      async (rImage) => {
                        if (rImage.ok) {
                          secondaryGuests = { ...item, image: rImage.data };
                        } else {
                          secondaryGuests = { ...item, image: null };
                        }
                      }
                    );
                  } else {
                    secondaryGuests = item;
                  }
                }
              }
            }

            setData({
              ...response.data,
              primaryGuest: {
                ...response.data.primaryGuest,
                image: imgPrimary,
              },
              secondaryGuests: secondaryGuests,
              otherGuests: response.data.secondaryGuests.filter(
                (item) => item.id !== queryParams.get("renterId")
              ),
              renterId: queryParams.get("renterId"),
            });

            setDataAp({
              ...response.data,
              primaryGuest: {
                ...response.data.primaryGuest,
                image: imgPrimary,
              },
              secondaryGuests: secondaryGuests,
              otherGuests: response.data.secondaryGuests.filter(
                (item) => item.id !== queryParams.get("renterId")
              ),
              renterId: queryParams.get("renterId"),
            });
          }
        }
      );
    }
  }, []);

  React.useEffect(() => {
    if (!isMounted) {
      Mount();
      setMount(true);
    }
  }, [Mount, isMounted]);

  function removerBase64EAntes(texto) {
    if (!texto) return null;

    const indiceBase64 = texto.indexOf("base64,");

    if (indiceBase64 !== -1) {
      return texto.substring(indiceBase64 + 7);
    }

    return texto;
  }

  const isGuestFlow =
    role === "GUEST" ||
    (role === "NORMAL" && data?.renterId !== data?.primaryGuest?.id) || (role === "ADMIN" && data?.renterId !== data?.primaryGuest?.id);

  const activeSteps = isGuestFlow ? STEPS_GUEST : role === "SERVICE_PROVIDER" ? STEPS_SP : role === "TENANT" ? STEPS_TENANT : role === "VISITANT" ? STEPS_VISITANT : STEPS_DEFAULT;

  const handleFinalSubmit = (formData) => {
    errorModal.close();
    if (isGuestFlow) {
      const guestData = {
        id: data.renterId,
        name: formData.fullName,
        document: formData.docType === 1 ? masks.removeNumberMask(formData.docValue) : undefined,
        birthDate: formData.birthday
          ? masks.dataParaString(formData.birthday)
          : null,
        email: formData.email,
        phone: formData.phone,
        image: removerBase64EAntes(formData.primaryImage),
        passport: formData.docType === 2 ? formData.docValue : undefined,
      };
      call(null, api.renderGuest(guestData), (response) => {
        if (response.ok) setSuccess(true);
      });
      return;
    }

    let submitData: any[];

    if (role === "NORMAL" || role === "ADMIN") {
      submitData = [
        {
          id: data.primaryGuest.id,
          name: formData.fullName,
          document: formData.docType === 1 ? formData.docValue : undefined,
          birthDate: formData.birthday
            ? masks.dataParaString(formData.birthday)
            : null,
          email: formData.email,
          phone: formData.phone,
          image: removerBase64EAntes(formData.primaryImage),
          passport: formData.docType === 2 ? formData.docValue : undefined,
          vehiclePlate: formData.vehiclePlate || undefined,
        },
      ];
      try {
        const secondary = Number.parseInt(formData.number);
        if (secondary > data.secondaryGuests.length) {
          for (
            let index = data.secondaryGuests.length;
            index < secondary;
            index++
          ) {
            data.secondaryGuests.push({ id: undefined });
          }
        }
      } catch (error) {
        console.log(error);
      }
      for (let index = 0; index < data.secondaryGuests.length; index++) {
        if (formData["fullName" + index]) {
          submitData.push({
            id: data.secondaryGuests[index].id,
            reservationId: data.id,
            name: formData["fullName" + index],
            vehiclePlate: formData["vehiclePlate" + index],
            document:
              formData["docType" + index] === 1
                ? formData["docValue" + index]
                : undefined,
            birthDate: formData["birthday" + index]
              ? masks.dataParaString(formData["birthday" + index])
              : null,
            email: formData["email" + index],
            phone: formData["phone" + index],
            image: removerBase64EAntes(
              formData.file?.current?.["other-" + index]
            ),
            passport:
              formData["docType" + index] === 2
                ? formData["docValue" + index]
                : undefined,
          });
        }
      }
    } else if (role === "TENANT") {
      submitData = [
        {
          id: data.primaryGuest.id,
          name: formData.name,
          document: formData.docType === 1 ? formData.docValue : undefined,
          passport: formData.docType === 2 ? formData.docValue : undefined,
          phone: formData.phone,
          email: formData.email,
          image: removerBase64EAntes(formData.primaryImage),
        },
      ];
    } else {
      // VISITANT, SERVICE_PROVIDER
      submitData = [
        {
          id: data.primaryGuest.id,
          name: data.primaryGuest.name,
          document: data.primaryGuest.document || undefined,
          passport: data.primaryGuest.passport || undefined,
          email: data.primaryGuest.email || undefined,
          phone: data.primaryGuest.phone || undefined,
          birthDate: data.primaryGuest.birthDate || undefined,
          image: removerBase64EAntes(formData.primaryImage),
        },
      ];
    }

    call(null, api.renderAll(submitData), (response) => {
      if (response.ok) setSuccess(true);
    });
  };

  const handleStepComplete = (formValues: any) => {
    const accumulated = { ...stepData, ...formValues };
    setStepData(accumulated);
    if (currentStep < activeSteps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleFinalSubmit(accumulated);
    }
  };

  const onSubmitVisitant = (formData) => {
    errorModal.close();
    const visitantData = {
      id: data.id,
      name: data.primaryGuest.name,
      document: data.primaryGuest.document,
      image: removerBase64EAntes(formData.primaryImage),
    };

    call(null, api.updateVisitant(visitantData), (response) => {
      if (response.ok) {
        setSuccess(true);
      }
    });
  };

  const renderStep0 = () => {
    if (!data || !role) return null;
    if (isGuestFlow)
      return <GuestConfirmStep data={data} onSubmit={handleStepComplete} />;
    if (role === "NORMAL")
      return <ReservationForm data={data} onSubmit={handleStepComplete} initialValues={stepData} />;
    if (role === "TENANT")
      return <TenantForm data={data} onSubmit={handleStepComplete} initialValues={stepData} />;
    if (role === "VISITANT")
      return <VisitantForm data={data} onSubmit={handleStepComplete} />;
    if (role === "SERVICE_PROVIDER")
      return <ServiceProviderForm data={data} onSubmit={handleStepComplete} />;
    if (role === "ADMIN")
      return <ReservationFormADMIN data={data} onSubmit={handleStepComplete} initialValues={stepData} />;
    return null;
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return renderStep0();
      case 1:
        if (isGuestFlow)
          return (
            <GuestForm
              data={data}
              onBack={() => setCurrentStep(0)}
              onSubmit={handleStepComplete}
              initialValues={stepData}
            />
          );
        return (
          <WebcamModal
            data={data?.place?.configurationParameters || data?.places?.[0]?.configurationParameters}
            userId={data.primaryGuest?.id ?? data.id}
            docType={stepData.docType}
            docValue={stepData.docValue}
            guestImage={data.primaryGuest?.image ?? undefined}
            onSubmit={(photoData) =>
              handleStepComplete({ primaryImage: photoData.src })
            }
            onBack={() => setCurrentStep((s) => s - 1)}
          />
        );
      case 2:
        return (
          <WebcamModal
            data={data?.place?.configurationParameters || data?.places?.[0]?.configurationParameters}
            userId={data.renterId ?? data.primaryGuest?.id ?? data.id}
            docType={stepData.docType}
            docValue={stepData.docValue}
            guestImage={data.secondaryGuests?.image ?? undefined}
            onSubmit={(photoData) =>
              handleStepComplete({ primaryImage: photoData.src })
            }
            onBack={() => setCurrentStep(1)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {loading ? (
        <StylesForm.ContainerExtra>
          <CircularProgress />
        </StylesForm.ContainerExtra>
      ) : success ? (
        <StylesForm.ContainerExtra>
          <CustomText fontSize={2.5}>Dados enviados com sucesso!</CustomText>
        </StylesForm.ContainerExtra>
      ) : data ? (
        <StylesForm.Container>
          <StepHeader dataAp={dataAp} steps={activeSteps} currentStep={currentStep} />
          <div
            style={{
              background: "#D2D2D2",
              width: "100%",
              marginBlock: "20px",
              minHeight: "5px",
            }}
          />
          {renderStep()}
          <MenssageWhatsapp
            data={data}
            renterId={data?.renterId}
            toNumber={process.env.REACT_APP_PHONE_FACIAL}
          >
            Tendo problemas com a facial?
          </MenssageWhatsapp>
        </StylesForm.Container>
      ) : (
        <StylesForm.ContainerExtra>
          <CustomText>Sem Dados</CustomText>
        </StylesForm.ContainerExtra>
      )}
    </>
  );
}

export default Home;
